import {useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {FaTimes} from 'react-icons/fa'
import {useSelector} from 'react-redux'
import {resizeImageToFixedDimensions, validateImageFile} from '../../utils/imageUtils'

function Tab1({values, handleChange, setFieldValue, errors, touched}) {
  const cohortOptions = useSelector((state) => state?.cohort?.records)
  const languageOptions = useSelector((state) => state?.language?.records)
  const categoryOptions = useSelector((state) => state?.category?.records)
  const seasonOptions = useSelector((state) => state?.season?.records)
  const [isResizingBannerImage, setIsResizingBannerImage] = useState(false)
  const [isResizingSquareImage, setIsResizingSquareImage] = useState(false)

  // Banner image URL
  let bannerImageURL = ''
  if (values.isEdit) {
    if (values.bannerImage) {
      bannerImageURL = values.bannerImage ? URL.createObjectURL(values.bannerImage) : ''
    } else {
      bannerImageURL = values.bannerImgUrl
    }
  } else {
    bannerImageURL = values.bannerImage ? URL.createObjectURL(values.bannerImage) : ''
  }

  // Square image URL
  let squareImageURL = ''
  if (values.isEdit) {
    if (values.squareImage) {
      squareImageURL = values.squareImage ? URL.createObjectURL(values.squareImage) : ''
    } else {
      squareImageURL = values.squareImgUrl
    }
  } else {
    squareImageURL = values.squareImage ? URL.createObjectURL(values.squareImage) : ''
  }

  const handleBannerImageChange = async (e) => {
    const file = e.currentTarget.files?.[0]
    if (!file) return

    try {
      setIsResizingBannerImage(true)

      // Validate the file
      validateImageFile(file)

      // Resize the banner image to fixed dimensions 512x256
      const resizedFile = await resizeImageToFixedDimensions(file, 512, 256)

      // Set the resized file in the form
      setFieldValue('bannerImage', resizedFile)
      setFieldValue('bannerMediaId', null)
    } catch (error) {
      console.error('Error processing banner image:', error)
      alert(`Error processing banner image: ${error.message}`)
    } finally {
      setIsResizingBannerImage(false)
      // Clear the input to allow selecting the same file again
      e.target.value = ''
    }
  }

  const handleSquareImageChange = async (e) => {
    const file = e.currentTarget.files?.[0]
    if (!file) return

    try {
      setIsResizingSquareImage(true)

      // Validate the file
      validateImageFile(file)

      // Resize the square image to fixed dimensions 512x568
      const resizedFile = await resizeImageToFixedDimensions(file, 512, 568)

      // Set the resized file in the form
      setFieldValue('squareImage', resizedFile)
      setFieldValue('squareMediaId', null)
    } catch (error) {
      console.error('Error processing square image:', error)
      alert(`Error processing square image: ${error.message}`)
    } finally {
      setIsResizingSquareImage(false)
      // Clear the input to allow selecting the same file again
      e.target.value = ''
    }
  }

  return (
    <div className='col-lg-12'>
      <div className='row align-items-start'>
        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Course Code</label>
          <input
            type='text'
            placeholder='Course code'
            name='code'
            value={values.code}
            onChange={handleChange}
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
          />
          {touched.code && errors.code && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.code}
              </span>
            </div>
          )}
        </div>

        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Course Title</label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            placeholder='Course name'
            name='title'
            value={values.title}
            onChange={handleChange}
          />
          {touched.title && errors.title && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.title}
              </span>
            </div>
          )}
        </div>
        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Author Name</label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
            placeholder='Author name'
            name='authorName'
            value={values.authorName}
            onChange={handleChange}
          />
          {touched.authorName && errors.authorName && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.authorName}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className='row mt-3'>
        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Select Language</label>
          <select
            className='form-select form-select-solid text-muted select2-hidden-accessible'
            name='layout-builder[layout][toolbar][width]'
            value={values.languageId}
            onChange={(e) => {
              const selectedLanguage = languageOptions.find(
                (language) => language.id === e.target.value
              )
              setFieldValue('languageId', selectedLanguage?.id)
              setFieldValue('language', selectedLanguage?.name)
            }}
          >
            <option disabled value={''}>
              Select Langage
            </option>
            {languageOptions.map((language) => (
              <option key={language.id} value={language.id}>
                {language.name}
              </option>
            ))}
          </select>
          {touched.languageId && errors.languageId && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.languageId}
              </span>
            </div>
          )}
        </div>
        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Select Cohort</label>
          <select
            className='form-select form-select-solid text-muted select2-hidden-accessible'
            name='cohort'
            value={values.cohortId}
            onChange={(e) => {
              const selectedCohort = cohortOptions.find((cohort) => cohort.id === e.target.value)
              setFieldValue('cohortId', selectedCohort?.id)
              setFieldValue('cohort', selectedCohort?.title)
            }}
          >
            <option disabled value={''}>
              Select Cohort
            </option>
            {cohortOptions.map((cohort) => (
              <option key={cohort.id} value={cohort.id}>
                {cohort.title}
              </option>
            ))}
          </select>
          {touched.cohortId && errors.cohortId && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.cohortId}
              </span>
            </div>
          )}
        </div>

        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Select Category</label>
          <select
            className='form-select form-select-solid text-muted select2-hidden-accessible'
            name='layout-builder[layout][toolbar][width]'
            value={values.categoryId}
            onChange={(e) => {
              const selectedCategory = categoryOptions.find(
                (category) => category.id === e.target.value
              )
              setFieldValue('categoryId', selectedCategory?.id)
              setFieldValue('category', selectedCategory.name)
            }}
          >
            <option disabled value={''}>
              Select Category
            </option>
            {categoryOptions.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
          {touched.categoryId && errors.categoryId && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.categoryId}
              </span>
            </div>
          )}
        </div>
      </div>

      <div className='row mt-3'>
        <div className='col-lg-4'>
          <label className='col-form-label required fw-bold fs-6'>Select Season</label>
          <select
            className='form-select form-select-solid text-muted select2-hidden-accessible'
            name='cohort'
            value={values.seasonId}
            onChange={(e) => {
              const selectedSeason = seasonOptions.find((season) => season.id === e.target.value)
              setFieldValue('seasonId', selectedSeason?.id)
              setFieldValue('season', selectedSeason?.name)
            }}
          >
            <option disabled value={''}>
              Select Season
            </option>
            {seasonOptions.map((season) => (
              <option key={season.id} value={season.id}>
                {season?.name}
              </option>
            ))}
          </select>
          {touched.seasonId && errors.seasonId && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.seasonId}
              </span>
            </div>
          )}
        </div>
        <div className='col-lg-4'>
          <label className='col-form-label fw-bold fs-6 d-block'>Is Featured</label>
          <label className='form-check d-inline-block form-check-custom form-check-solid form-switch mt-2'>
            <input
              className='form-check-input'
              type='checkbox'
              checked={values.isFeatured}
              onClick={() => setFieldValue('isFeatured', !values.isFeatured)}
            />
          </label>
        </div>
        <div className='col-lg-4'>
          <label className='col-form-label fw-bold fs-6 d-block'>For BlackForce Member</label>
          <label className='form-check d-inline-block form-check-custom form-check-solid form-switch mt-2'>
            <input
              className='form-check-input'
              type='checkbox'
              checked={values?.isForBlackforceMember}
              onClick={() => setFieldValue('isForBlackforceMember', !values?.isForBlackforceMember)}
            />
          </label>
        </div>
      </div>

      <div className='d-flex align-items-start mt-lg-8 gap-10 flex-wrap'>
        {/* Banner Image Upload */}
        <div>
          <label className='col-form-label required fw-bold fs-6'>Banner Image</label>
          {!values.bannerImage && !values.bannerImgUrl ? (
            <div>
              <div
                className='d-flex flex-column justify-content-center align-items-center bg-light-primary px-6 rounded-2 mb-7'
                onClick={() =>
                  !isResizingBannerImage && document.getElementById('bannerFileInput')?.click()
                }
                style={{
                  cursor: isResizingBannerImage ? 'not-allowed' : 'pointer',
                  width: '512px',
                  height: '256px',
                }}
              >
                {isResizingBannerImage ? (
                  <>
                    <div className='spinner-border text-primary' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </div>
                    <span className='text-primary fw-semibold fs-6 mt-2'>
                      Resizing banner image...
                    </span>
                  </>
                ) : (
                  <>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr075.svg'
                      className='svg-icon-3x svg-icon-primary d-block my-2'
                    />
                    <a href='#' className='text-primary fw-semibold fs-6'>
                      Upload Banner Image (512x256)
                    </a>
                  </>
                )}
              </div>
              {touched.bannerImage && errors.bannerImage && (
                <div className='fv-plugins-message-container'>
                  <span role='alert' className='text-danger'>
                    {errors.bannerImage}
                  </span>
                </div>
              )}
              <input
                id='bannerFileInput'
                type='file'
                accept='image/*'
                style={{display: 'none'}}
                disabled={isResizingBannerImage}
                onChange={(e) => handleBannerImageChange(e)}
              />
            </div>
          ) : (
            <div className='mb-8' style={{position: 'relative', width: '512px', height: '256px'}}>
              <img
                src={bannerImageURL}
                style={{width: '512px', height: '256px', objectFit: 'contain'}}
              />
              <div
                className='rounded-3 p-1'
                style={{position: 'absolute', top: '4px', right: '4px', background: 'white'}}
              >
                <FaTimes
                  style={{
                    color: 'black',
                    cursor: 'pointer',
                    fontSize: '18px',
                    backgroundPosition: 'center center',
                  }}
                  onClick={() => {
                    setFieldValue('bannerImage', null)
                    setFieldValue('bannerImgUrl', null)
                  }}
                />
              </div>
            </div>
          )}
        </div>

        {/* Square Image Upload */}
        <div>
          <label className='col-form-label required fw-bold fs-6'>Square Image</label>
          {!values.squareImage && !values.squareImgUrl ? (
            <div>
              <div
                className='d-flex flex-column justify-content-center align-items-center bg-light-primary px-6 rounded-2 mb-7'
                onClick={() =>
                  !isResizingSquareImage && document.getElementById('squareFileInput')?.click()
                }
                style={{
                  cursor: isResizingSquareImage ? 'not-allowed' : 'pointer',
                  width: '231px',
                  height: '256px',
                }}
              >
                {isResizingSquareImage ? (
                  <>
                    <div className='spinner-border text-secondary' role='status'>
                      <span className='visually-hidden'>Loading...</span>
                    </div>
                    <span className='text-secondary fw-semibold fs-6 mt-2'>
                      Resizing square image...
                    </span>
                  </>
                ) : (
                  <>
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr075.svg'
                      className='svg-icon-3x svg-icon-primary d-block my-2'
                    />
                    <a href='#' className='text-primary fw-semibold fs-6 text-center'>
                      Upload Square Image (512x568)
                    </a>
                  </>
                )}
              </div>
              {touched.squareImage && errors.squareImage && (
                <div className='fv-plugins-message-container'>
                  <span role='alert' className='text-danger'>
                    {errors.squareImage}
                  </span>
                </div>
              )}
              <input
                id='squareFileInput'
                type='file'
                accept='image/*'
                style={{display: 'none'}}
                disabled={isResizingSquareImage}
                onChange={(e) => handleSquareImageChange(e)}
              />
            </div>
          ) : (
            <div className='mb-8' style={{position: 'relative', width: '231px', height: '256px'}}>
              <img
                src={squareImageURL}
                style={{width: '231px', height: '256px', objectFit: 'cover'}}
              />
              <div
                className='rounded-3 p-1'
                style={{position: 'absolute', top: '4px', right: '4px', background: 'white'}}
              >
                <FaTimes
                  style={{
                    color: 'black',
                    cursor: 'pointer',
                    fontSize: '18px',
                    backgroundPosition: 'center center',
                  }}
                  onClick={() => {
                    setFieldValue('squareImage', null)
                    setFieldValue('squareImgUrl', null)
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className='row mt-lg-3 align-items-center'>
        <div className='col-lg-6'>
          <label className='col-form-label required fw-bold fs-6'>Short Description</label>
          <textarea
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 '
            style={{height: '200px', width: '100%'}}
            placeholder='Short description'
            name='shortDescription'
            value={values.shortDescription}
            onChange={(e) => {
              if (e.target.value.length <= 150) {
                handleChange(e)
              }
            }}
          />
          <small className='text-muted'>{values.shortDescription.length}/150 characters</small>
          {touched.shortDescription && errors.shortDescription && (
            <div className='fv-plugins-message-container'>
              <span role='alert' className='text-danger'>
                {errors.shortDescription}
              </span>
            </div>
          )}
        </div>
      </div>

      <div>
        <label className='col-form-label required fw-bold fs-6'>Long Description</label>
        <textarea
          className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
          style={{height: '200px'}}
          placeholder='Long description'
          name='longDescription'
          value={values.longDescription}
          onChange={handleChange}
        />
        {touched.longDescription && errors.longDescription && (
          <div className='fv-plugins-message-container'>
            <span role='alert' className='text-danger'>
              {errors.longDescription}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default Tab1
